import { UseCase } from '@mdd/api';
import { User } from '../../models';

export class HasPrairieFarmsMemberCenterAccess implements UseCase<User | undefined, boolean> {
    execute(user: User | undefined): boolean {
        return !!user && user.permissions.includes('PRAIRIEFARMS_MEMBER_CENTER');
    }
}
